<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              email
            </v-icon>
            <span class="title">Surat <b>{{ this.kodesurat }}</b></span>
          </v-card-title>
          <v-card-text v-if="detaildata">
            <v-container>
              <v-row justify="center">
                <v-col cols="12" md="8" class="px-10 border-solid-thin text-justify">
                  <v-row justify="center" align="center">
                    <v-col cols="12" md="2" class="text-center">
                      <img class="mr-3" :src="require('../../assets/logo-pnb.png')" height="100"/>
                    </v-col>
                    <v-col cols="12" md="10" class="text-center">
                      <div class="headline">PEMERINTAH KABUPATEN KLUNGKUNG</div>
                      <div class="headline">KECAMATAN DAWAN</div>
                      <div class="headline">DESA PIKAT</div>
                      <p>Jln. Desa Pikat | No.Telp: (0366) 30267 | Kode Pos: 80761</p>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <div class="text-center text-underline title mb-3">SURAT KETERANGAN</div>
                      <div class="text-center">Nomor: _______/_______/_______/_______</div>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Yang bertanda tangan dibawah ini:</p>
                      <table class="ml-5">
                        <tr>
                          <td>Nama</td>
                          <td>:</td>
                          <td><b>{{ detaildata.acc_js }}</b></td>
                        </tr>
                        <tr>
                          <td>Jabatan</td>
                          <td>:</td>
                          <td><b>Perbekel Desa Pikat</b></td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Dengan ini menerangkan sebenarnya:</p>
                      <table class="ml-5">
                        <tr>
                          <td>Nama</td>
                          <td>:</td>
                          <td><b>{{ detaildata.nama }}</b></td>
                        </tr>
                        <tr>
                          <td>Tempat / Tanggal Lahir</td>
                          <td>:</td>
                          <td><b>{{ detaildata.tempat_lahir }} / {{ detaildata.tanggal_lahir }}</b></td>
                        </tr>
                        <tr>
                          <td>Jenis Kelamin</td>
                          <td>:</td>
                          <td><b>{{ detaildata.kelamin | kelaminParse }}</b></td>
                        </tr>
                        <tr>
                          <td>Agama</td>
                          <td>:</td>
                          <td><b>{{ detaildata.agama }}</b></td>
                        </tr>
                        <tr>
                          <td>Pekerjaan</td>
                          <td>:</td>
                          <td><b>{{ detaildata.pekerjaan }}</b></td>
                        </tr>
                        <tr>
                          <td>Alamat</td>
                          <td>:</td>
                          <td><b>{{ detaildata.alamat }}</b></td>
                        </tr>
                        <tr>
                          <td>Nomor KK</td>
                          <td>:</td>
                          <td><b>{{ detaildata.no_kk }}</b></td>
                        </tr>
                        <tr>
                          <td>Nomor NIK</td>
                          <td>:</td>
                          <td><b>{{ detaildata.nik }}</b></td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>{{ updatesurat.deskripsi_surat }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <p>Demikian surat keterangan ini kami buat dengan sebenarnya untuk dapat dipergunakan sebagaimana mestinya.</p>
                    </v-col>
                  </v-row>
                  <v-row justify="end">
                    <v-col cols="12" md="4" class="text-center">
                      <div>Pikat, {{ new Date() | dateToIndo }}</div>
                      <div>Perbekel Desa Pikat</div>
                      <br/>
                      <br/>
                      <br/>
                      <div>( {{ detaildata.acc_js }} )</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-10">
                  <alertsp :alertdata="alertdata"></alertsp>
                  <v-form
                    ref="formupdatesurat"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nama_js"
                          label="Jenis Surat"
                          name="jenis_surat">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nama"
                          label="Nama Pemohon"
                          name="nama">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="updatesurat.deskripsi_surat"
                          auto-grow
                          label="Deskripsi Surat"
                          :rules="[rules.required]"
                          rows="1">
                        </v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="liststatus"
                          name="statussurat"
                          v-model="updatesurat.status_surat"
                          label="Status Surat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" v-if="updatesurat.status_surat === 'selesai'">
                        <v-text-field
                          v-model="updatesurat.no_surat"
                          :rules="[rules.required]"
                          label="Nomor Surat"
                          name="nosurat"
                          required>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn
                          large
                          block
                          :disabled="!formadd.valid"
                          color="success"
                          class="mr-4 mt-5"
                          @click="submitUpdate">
                          Simpan
                        </v-btn>
                        <v-btn
                          large
                          block
                          :disabled="!urlprint"
                          color="primary"
                          class="mr-4 mt-5"
                          :href="urlprint"
                          target="_blank">
                          Cetak
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :to="{ name: 'SuratAdmin' }"
              text
              color="orange">
              Back
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';

export default {
  name: 'SuratDetailAdmin',
  props: ['kodesurat'],
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    api: process.env.VUE_APP_API,
    liststatus: ['permohonan', 'proses', 'siap', 'selesai', 'batal'],
    detaildata: null,
    updatesurat: {
      deskripsi_surat: '',
      status_surat: '',
      kode_surat: '',
      no_surat: '',
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
    },
    urlprint: '',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
  },
  mounted() {
    if (this.kodesurat) {
      this.getDetailSurat();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    getDetailSurat() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/surat/' + this.kodesurat,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.detaildata = resdata.data[0];
                this.updatesurat.kode_surat = resdata.data[0].kode_surat;
                this.updatesurat.deskripsi_surat = resdata.data[0].deskripsi_surat;
                this.updatesurat.status_surat = resdata.data[0].status_surat;
                this.urlprint = this.api + '/public/surat/' + this.kodesurat + '/' + resdata.data[0].nik_surat;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/surat/',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kode_surat + '" berhasil diperbaharui!';
                  // this.getDetailSurat();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
